<template>
  <v-layout align-start>
    <v-flex>
      <v-container fluid>
        <v-row no-gutters justify="center">
          <span style="font-size: 34px; color: #616161">Metodos de pagos</span>
        </v-row>
        <v-card outlined>
          <v-card-text>
            <v-card flat class="mt-0 pt-0">
              <v-card-text class="mt-0 pt-0">
                <v-data-table :headers="headersItbis" :search="search" :items="payments">
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Pagos</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <span>{{ payments.length }}</span>
                      <v-spacer></v-spacer>
                      <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Buscar"
                        single-line hide-details>
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-divider class="mx-3" inset vertical></v-divider>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn color="primary" class="mr-2" v-bind="attrs" v-on="on" outlined @click="clearItbis()">
                            Nuevo metodo de pago
                            <v-icon>add</v-icon>
                          </v-btn>
                        </template>
                        <span>Crear nuevo metodo</span>
                      </v-tooltip>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.chart_of_account_id`]="{ item }">
                    <span v-if="chartOfAccount.length > 0">{{
                      chartOfAccount.filter((element) => element.id == item.chart_of_account_id)[0].name }}</span>
                  </template>
                  <template v-slot:[`item.supply_chart_of_account_id`]="{ item }">
                    <span v-if="chartOfAccount.length > 0">{{
                      chartOfAccount.filter((element) => element.id == item.supply_chart_of_account_id)[0].name }}</span>
                  </template>
                  <template v-slot:[`item.edit`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" medium color="blue" @click="editPayment(item)">
                          edit
                        </v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-dialog v-model="dialogEdit" max-width="50%">
            <v-card outlined>
              <v-card-title class="mb-3">
                <span>{{ titleDialog }}</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialogEdit = false">
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row justify="center">
                    <v-col cols="12" sm="3" md="12">
                      <v-text-field class="text-xs-center" v-model="newPayments.name" label="Descripcion" outlined>
                      </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3" md="12">
                      <v-autocomplete v-model="newPayments.chart_of_account_id" :items="chartOfAccount" item-value="id"
                        item-text="name" color="cyanText" label="Cuenta contable" outlined required>
                      </v-autocomplete>
                    </v-col>
                    \
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" text @click="savePayment()" :loading="loadingSave">
                  {{ nameButon }}
                </v-btn>
                <v-btn color="error" text @click="dialogEdit = false">
                  Cancelar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: () => ({
    search: "",
    payments: [],
    newPayments: {
      name: "",
      chart_of_account_id: "",
      supply_chart_of_account_id: "",
      percent: 0.0,
      value: 0,
    },
    headersItbis: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      { text: "Descripcion", value: "name" },
      { text: "Cuenta contable", value: "chart_of_accounts_name" },

      { text: "Editar", value: "edit", sortable: false },
    ],
    dialogEdit: false,
    chartOfAccount: [],
    nameButon: "",
    is_new_Withholdings: true,
    titleDialog: "",
    loadingSave: false,
  }),
  components: {},
  created() {
    this.initialized();
  },
  computed: {},
  watch: {},
  methods: {
    async initialized() {

      await this.getData();
      const resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      let accounts=await resultTypeAccounts.json();
      accounts.forEach(element => {
        element.name=element.name+" (" +element.code+")"
        this.chartOfAccount.push({
          name: element.code+" - "+ element.name,
          id: element.id,
        
        })
      });
   
    },
    async getData() {

      const request = await this.api_Get("income/payments_types");
      const data = await request.json();

      if (request.status == 200) {
        this.payments = data;

      }
    },
    editPayment(item) {
      this.is_new_Withholdings = false;
      this.titleDialog = "Editar " + item.id + "-" + item.name;
      this.newPayments = Object.assign({}, item);
      this.newPayments.value = (item.value * 100).toFixed(2);
      this.nameButon = "Actualizar";
      this.dialogEdit = true;
    },
    clearItbis() {
      this.clearDialog();
      this.titleDialog = "Nuevo payments ";
      this.nameButon = "Guardar";
      this.dialogEdit = true;
    },
    clearDialog() {
      this.newPayments = {
        chart_of_account_id: "",
        percent: 0.0,
        porcentaje: 0,
      };
    },
    async savePayment() {
      this.loadingSave = true;

      let datos = {
        id: this.newPayments.id,
        name: this.newPayments.name,
        chart_of_account_id: this.newPayments.chart_of_account_id,

      };
      const result = await this.api_Put("income/update_type_payments", datos);


      // src="http://128.1.4.88:3040/api/recruitment/persons/file/1/241427">
      if (result.status == 200) {
        this.$toast.success("Cambios guardados con exito!");
      }

      this.dialogEdit = false;
      this.loadingSave = false;
      this.initialized()
    },
  },
};
</script>
    